import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
       width: '100%',
       display: 'flex',
       flexDirection: "column",
       alignItems: 'center'
    },

    MuiStep_horizontal: {
        background: '#d3d3d3ad'
    },

    stepIcons: {
        color: '#1aaecc',
        '&:focus': {
          outline: 'none'
        }
    },
    buttonContainer: {
        // position: 'absolute',
        // bottom: '0',
         display: 'flex',
        // width: '77%',
         //flexDirection: 'column',
         marginTop: '20px',
         justifyContent: 'space-between',
    },
    button: {
        backgroundColor: '#1aaecc',
        color: 'white',
        '&:disabled': {
            backgroundColor: '#a7a9aa75',
            color: 'white'
        },
        '&:hover': {
          background: '#1aaecc',
          opacity: '0.8',
       },
       '&:focus': {
         outline: 'none',
       }
    },
    main_container: {
        width: '100%',
        textAlign: 'center',
        marginTop: '30px',
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    paper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '190px',
        width: '240px',
        margin: '15px 30px',
        //backgroundColor: 'rgba(255, 255, 255, 0.8)',
        backgroundColor: '#F0F1F3',
        cursor: 'pointer',

        "&:hover": {
            backgroundColor: 'rgba(101, 202, 252, 0.8)',
        }

    },
}));